import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./queuedView.html";
import { validateAndDeploy } from '../services/validateAndDeployService';
import { BUTTONS_IDS } from '../utils/appConstants';
const {
  VALIDATE_ID
} = BUTTONS_IDS;
class QueuedView extends LightningElement {
  constructor(...args) {
    super(...args);
    this.disableDeploy = void 0;
    this.disableOverwrite = void 0;
    this.selectedItems = [];
    this.validatedItems = [];
    this.nonDuplicateValidatedItems = [];
    this.updatedSelectedItems = [];
    this.disableValidate = void 0;
    this.shouldOverwrite = false;
    this.isImportFileEnabled = false;
    this.importFileUniqueID = null;
    this.handleOverwriteCheckbox = event => {
      this.shouldOverwrite = event.target.checked;
      this.disableDeploy = !event.target.checked;
    };
    this.updateQueuedViewFooterAfterValidation = (disableOverwrite, disableDeploy) => {
      this.disableOverwrite = disableOverwrite;
      this.disableDeploy = disableDeploy;
    };
    this.updateQueuedViewFooter = (disableDeploy, disableOverwrite) => {
      this.disableDeploy = disableDeploy;
      this.disableOverwrite = disableOverwrite;
      this.template.querySelector('lightning-input[data-my-id="overwriteItemId"]').checked = false;
    };
    this.updateOverwriteValueAfterDeploy = isOverwrite => {
      this.shouldOverwrite = isOverwrite;
    };
    this.handleClearList = () => {
      this.selectedItems = [];
      this.updatedSelectedItems = [];
      this.shouldOverwrite = false;
      const clearListEvent = new CustomEvent('clearqueuedlist', {
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(clearListEvent);
      const clearQueuedCount = new CustomEvent('clearqueuedcount', {});
      this.dispatchEvent(clearQueuedCount);
    };
    this.handleValidateAndDeploy = evt => {
      const me = this;
      const showProgressbar = new CustomEvent('showvalidatedeployprogressbar', {
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(showProgressbar);
      const buttonId = evt.target.dataset.myId;
      const allValidatedItems = me.validatedItems.concat(me.nonDuplicateValidatedItems);
      let finalDeployItems = me.shouldOverwrite ? JSON.parse(JSON.stringify(allValidatedItems)) : me.nonDuplicateValidatedItems;
      if (finalDeployItems && me.shouldOverwrite) {
        const ids = finalDeployItems.map(o => o.id);
        finalDeployItems = finalDeployItems.filter(({
          id
        }, index) => !ids.includes(id, index + 1));
      }
      let isTranslation = false;
      for (let index = 0; index < me.selectedItems.length; index++) {
        const {
          componentType,
          translationConfigurations
        } = me.selectedItems[index];
        if (componentType == undefined) {
          isTranslation = true;
          me.updatedSelectedItems = [...me.updatedSelectedItems, ...translationConfigurations];
          me.updatedSelectedItems = me.formatUpdatedSelConfigs(me.updatedSelectedItems);
        }
      }
      if (buttonId === VALIDATE_ID) {
        isTranslation = false;
        me.updatedSelectedItems = me.selectedItems;
      }
      const config = {
        isValidate: buttonId === VALIDATE_ID ? true : false,
        isOverwrite: buttonId === VALIDATE_ID ? false : me.shouldOverwrite,
        queuedDataList: buttonId === VALIDATE_ID || isTranslation ? me.updatedSelectedItems : finalDeployItems,
        isImportFileEnabled: me.isImportFileEnabled,
        importFileUniqueID: me.importFileUniqueID
      };
      validateAndDeploy(config);
    };
    this.updateImportFileValue = (isImportFileEnabled, importFileUniqueID) => {
      this.isImportFileEnabled = isImportFileEnabled;
      this.importFileUniqueID = importFileUniqueID;
    };
    this.formatUpdatedSelConfigs = selConfigs => {
      let tempSelConfigs = [];
      if (selConfigs.length > 0) {
        for (let index = 0; index < selConfigs.length; index++) {
          const {
            componentType,
            configType,
            componentName,
            createdBy,
            createdOn,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          } = selConfigs[index];
          const formattedRow = {
            componentType,
            configType,
            componentName,
            createdBy,
            createdOn,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          };
          tempSelConfigs.push(formattedRow);
        }
      }
      return tempSelConfigs;
    };
  }
}
_registerDecorators(QueuedView, {
  publicProps: {
    disableDeploy: {
      config: 0
    },
    disableOverwrite: {
      config: 0
    },
    selectedItems: {
      config: 0
    },
    validatedItems: {
      config: 0
    },
    nonDuplicateValidatedItems: {
      config: 0
    },
    updatedSelectedItems: {
      config: 0
    },
    disableValidate: {
      config: 0
    },
    updateQueuedViewFooterAfterValidation: {
      config: 0
    },
    updateQueuedViewFooter: {
      config: 0
    },
    updateOverwriteValueAfterDeploy: {
      config: 0
    },
    handleClearList: {
      config: 0
    },
    updateImportFileValue: {
      config: 0
    }
  },
  fields: ["shouldOverwrite", "isImportFileEnabled", "importFileUniqueID", "handleOverwriteCheckbox", "handleValidateAndDeploy", "formatUpdatedSelConfigs"]
});
export default _registerComponent(QueuedView, {
  tmpl: _tmpl
});